import {
  LitElement,
  html
} from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import SkipToMainStyle from './style.js';

export class LdsSkipToMain extends LitElement {
  static get styles() {
    return SkipToMainStyle;
  }

  static properties = {
    contentId: { type: String },
    isSideNav: { type: Boolean },
  };

  constructor() {
    super();
    this.contentId = 'main';
    this.isSideNav = false;
  }

  render() {
    return html`
      <div class="lds-skip-to-main ${classMap({ sideNav: this.isSideNav })}">
        <a
          class="lds-skip-link"
          tabindex="0"
          href="#${this.contentId}"
        >
          <slot>Skip to main content</slot>
        </a>
        <div class="lds-skip-placeholder"></div>
      </div>
    `;
  }
}

export function defineComponent() {
  if (!window.customElements.get('lds-skip-to-main')) window.customElements.define('lds-skip-to-main', LdsSkipToMain);
}

export default { LdsSkipToMain, defineComponent };
